// extracted by mini-css-extract-plugin
module.exports = {"module":"PayrollTransactionBaseWithDate_module__2qMOI"};